var agp = agp || {};

agp.message = (function () {

	var element, timer, id = 0;

	function message(msg, state, timeout) {
		if (!element) {
			init();
		}

		if (msg === undefined || msg === false || msg === '') {
			reset();
			return;
		}


		message.history = message.history || [];
		message.history.push({
			id: id,
			date: new Date(),
			msg: msg,
			state: state,
			timeout: timeout
		});
		id++;


		element.html(msg);
		element.addClass('site-message--active' + (state === false ? ' site-message--danger' : ''));


		clearTimeout(timer);
		if (timeout === true) {
			timer = setTimeout(reset, 5000);
		} else if (typeof timeout === 'number' && !isNaN(timeout)) {
			timer = setTimeout(reset, timeout);
		}
	}

	function reset() {
		if (!element) {
			init();
		}
		element.removeClass(function (index, css) {
			return (css.match(/(^|\s)site-message--\S+/g) || []).join(' ');
		});
	}

	function init() {
		element = $('.site-message');

		element.off('click', reset);
		element.on('click', reset);

		return element;
	}

	return {
		message: message
	};

}());